import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const EditCompanyToPersonRelation = withSuspense(lazy(() => import('./edit-deal')));
export default EditCompanyToPersonRelation;
